module.exports = __webpack_public_path__ + "img/skydiving.de2b29cf.jpg";